(() => {
  const roots = document.querySelectorAll('[data-wagon-details]');
  if (!roots.length) return;

  const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  })[character]);
  const field = (label, value, paragraphs) => ({
    label,
    value,
    body: paragraphs.map(([heading, copy]) =>
      `<p><strong>${escapeHtml(heading)}</strong>${escapeHtml(copy)}</p>`
    ).join('')
  });

  const foldableWagons = {
    'foldbar-traekvogn-mini-model': {
      load: '40 kg', volume: '70 L', size: '82 × 36 cm', folded: '63 × 40 × 14 cm', weight: '5,7 kg',
      sizeNote: 'Produktbeskrivelsen oplyser kun to mål i brug; højden er ikke angivet. Brug derfor ikke tallet som et fuldstændigt udvendigt mål.',
      wheelValue: '4 store hjul',
      wheelNote: 'Beskrivelsen fremhæver de fire store hjul til ujævnt terræn. Underlagets beskaffenhed og vognens last påvirker stadig, hvor let den er at trække.',
      featureValue: 'Kompakt mini-model',
      featureNote: 'Det er den mindste foldbare model i udvalget og beregnet til transport af udstyr og forsyninger. Produktteksten oplyser ikke, at den er godkendt til persontransport.',
      buildNote: 'Den sammenklappelige konstruktion gør den nemmere at tage med og stille væk, når turen er slut.'
    },
    'traekvogn-basic': {
      load: '80 kg', volume: '110 L', size: '76 × 46 × 57 cm', folded: '67 × 52 × 17 cm', weight: '8,84 kg',
      sizeNote: 'Målene er angivet som længde, bredde og højde. Beskrivelsen skelner ikke mellem indvendige og udvendige mål, så mål større genstande før køb.',
      wheelValue: 'Massive PVC-hjul',
      wheelNote: 'Massive hjul skal ikke pumpes. De er praktiske til almindelig transport, men hårdt eller meget løst underlag kan påvirke, hvor let vognen kører.',
      featureValue: 'Fast bund',
      featureNote: 'Den faste bund giver et mere stabilt underlag til tasker og kasser. Vognen har stålstel og kraftigt Oxford-materiale.',
      buildNote: 'Vognen kan foldes sammen efter brug, så den fylder mindre i bil eller opbevaringsrum.'
    },
    'traekvogn-120-kg-premium': {
      load: '120 kg', volume: '150 L', size: '90 × 50 × 55 cm', folded: '64 × 36 × 23 cm', weight: '11,93 kg',
      sizeNote: 'De oplyste mål er længde, bredde og højde. Beskrivelsen angiver ikke, om alle tre mål er indvendige, så sammenlign med størrelsen på dit største udstyr.',
      wheelValue: 'Ekstra brede hjul',
      wheelNote: 'De massive PVC-hjul har en tynd gummibelægning og er ekstra brede. Det er en fordel på ujævnt underlag, men de er ikke oppustelige.',
      featureValue: 'Regnslag medfølger',
      featureNote: 'Vognen har fast bund, kraftigt Oxford-stof og stålstel med rustfrie bolte. Et regnslag følger med til beskyttelse af oppakningen.',
      buildNote: 'Den foldbare konstruktion er nyttig, når en stor vogn skal opbevares på mindre plads.'
    },
    'foldbar-traekvogn-med-tag-max-120-kg': {
      load: '120 kg', volume: '150 L', size: '90 × 50 × 55 cm', folded: '64 × 36 × 23 cm', weight: '11,93 kg',
      sizeNote: 'De oplyste mål er længde, bredde og højde. Produktteksten oplyser ikke, om højden omfatter det aftagelige tag.',
      wheelValue: 'Ekstra brede hjul',
      wheelNote: 'Hjulene er brede og fremstillet af massiv PVC. De kræver ikke luft, men føles anderledes end oppustelige hjul på meget ujævnt underlag.',
      featureValue: 'Aftageligt tag',
      featureNote: 'Det medfølgende vandtætte tag kan tages af, når du hellere vil have åben adgang til oppakningen. Vognen har desuden fast bund, Oxford-stof og stålstel.',
      buildNote: 'Vognen foldes sammen til opbevaring, og taget kan afmonteres særskilt.'
    },
    'foldbar-traekvogn-xl-max-100-kg': {
      load: '100 kg', volume: '180 L', size: '89 × 53 × 64 cm', folded: '68 × 36 × 24 cm', weight: '11,93 kg',
      sizeNote: 'Målene er oplyst som længde, bredde og højde. XL-modellens højere sider giver plads til mere voluminøs oppakning, men indvendige mål er ikke angivet.',
      wheelValue: 'Ekstra brede hjul',
      wheelNote: 'De brede, massive PVC-hjul har en tynd gummibelægning. De skal ikke pumpes, men trækkraften afhænger stadig af underlag og vægt.',
      featureValue: 'XL-plads',
      featureNote: 'Denne model rummer 180 liter og har kraftigt Oxford-stof samt stålstel med rustfrie bolte. Vælg den, når udstyret fylder mere end det vejer.',
      buildNote: 'Trods den store plads kan vognen foldes sammen, når den skal i bilen eller opbevares.'
    }
  };

  const buildFoldable = (spec) => ({
    heading: 'Detaljer om denne trækvogn',
    intro: 'Få nemt overblikket over bæreevne, plads, hjul og størrelse',
    fields: [
      field('Bæreevne', spec.load, [
        ['Den maksimale last.', `Vognen er oplyst til at kunne bære op til ${spec.load} bagage og udstyr. Fordel tunge ting jævnt i bunden, så vognen er lettere at styre.`],
        ['Vægt er ikke volumen.', `Grænsen på ${spec.load} handler om vægt. Store, lette genstande kan fylde vognen, før den maksimale belastning er nået.`]
      ]),
      field('Plads', spec.volume, [
        ['Volumen i vognen.', `Den oplyste kapacitet er ${spec.volume}. Det giver et sammenligningsgrundlag for, hvor meget oppakning vognen kan rumme.`],
        ['Pak efter formen.', 'Liter fortæller ikke, om én stor kasse kan være der. Sammenlign derfor også vognens mål med det udstyr, du vil transportere.']
      ]),
      field('Mål i brug', spec.size, [
        ['Oplyst størrelse.', spec.sizeNote],
        ['Når den er foldet.', `Den sammenfoldede størrelse er ${spec.folded}. Det er målet, du bør sammenligne med pladsen i bagagerummet eller skuret.`]
      ]),
      field('Hjul', spec.wheelValue, [
        ['Sådan er hjulene beskrevet.', spec.wheelNote],
        ['Vælg efter underlaget.', 'Prøv at holde lasten lavt og nogenlunde midt i vognen. På blødt sand eller meget ujævne stier kræves mere trækkraft.']
      ]),
      field('Egenvægt', spec.weight, [
        ['Vægten uden oppakning.', `Vognen vejer ${spec.weight}. Husk at den vægt skal løftes ind og ud af bilen, også før du lægger udstyr i.`],
        ['Transport og opbevaring.', spec.buildNote]
      ]),
      field('Særlige detaljer', spec.featureValue, [
        ['Det, der kendetegner modellen.', spec.featureNote],
        ['Før du vælger.', 'Sammenlign både bæreevne, volumen og den sammenfoldede størrelse med det, du faktisk skal have med på tur.']
      ])
    ]
  });

  const utilityWagons = {
    'traekvogn-robust-max-350-kg': {
      load: '350 kg', size: '96 × 51 × 22 cm', sizeType: 'Oplyste mål', weight: '17 kg',
      construction: 'Rustfrit gitter',
      constructionNote: 'Vognen har et rustfrit gitter omkring ladet. Den sælges i varianter med eller uden presenning; vælg varianten efter behov for overdækning.'
    },
    'traekvogn-med-gitter-xl-model-max-350-kg': {
      load: '350 kg', size: '108 × 51 × 41 cm', sizeType: 'Indvendige mål', weight: '17 kg',
      construction: 'Gitter + presenning',
      constructionNote: 'XL-modellen har rustfrit gitter og en aftagelig presenning. Presenningen kan bruges til at skærme lasten og tages af, når du vil have åben adgang.'
    },
    'traekvogn-ekstra-robust-max-500-kg': {
      load: '500 kg', size: '128 × 52 × 25 cm', sizeType: 'Mål på lad', weight: '28 kg',
      construction: 'Rustfrit gitter',
      constructionNote: 'Modellen er bygget til den højeste oplyste belastning i udvalget og har rustfrit gitter. Den er stor og tung, så planlæg, hvor den skal opbevares.'
    },
    'traekvogn-med-lad-max-150-kg': {
      load: '150 kg', size: '95 × 52 × 21 cm', sizeType: 'Mål på lad', weight: '14,5 kg',
      construction: 'Lad med 90° tilt',
      constructionNote: 'Ladet kan tiltes 90 grader, hvilket gør det nemmere at tømme det. Stellet er beskrevet som rustfrit metal.'
    }
  };

  const buildUtility = (spec) => ({
    heading: 'Detaljer om denne trækvogn',
    intro: 'Få nemt overblikket over lasteevne, lad, hjul og samling',
    fields: [
      field('Bæreevne', spec.load, [
        ['Maksimal oplyst belastning.', `Vognen er angivet til en last på op til ${spec.load}. Fordel vægten på ladet og sørg for, at godset ligger stabilt under transport.`],
        ['Vælg efter lasten.', 'Belastningsgrænsen er ikke det samme som pladsen på ladet. Tjek derfor også målene på de ting, du vil flytte.']
      ]),
      field(spec.sizeType, spec.size, [
        ['Plads til udstyret.', `Produktbeskrivelsen angiver ${spec.sizeType.toLowerCase()} på ${spec.size}. Brug målene til at vurdere, om kasser, haveudstyr eller campinggrej kan ligge på ladet.`],
        ['Mål før køb.', spec.sizeType === 'Oplyste mål' ? 'Beskrivelsen siger ikke, om disse mål er indvendige eller udvendige. Regn derfor ikke hele målet som fri lasteplads.' : 'Udstyr, der stikker ud over ladet, kræver særlig omtanke og sikker fastgørelse.']
      ]),
      field('Hjul', 'Oppustelige', [
        ['Luftfyldte hjul.', 'De oppustelige hjul kan absorbere noget af ujævnhederne i underlaget. Kontrollér lufttrykket, før du kører med en tung last.'],
        ['Vedligeholdelse.', 'I modsætning til massive hjul kan luftfyldte hjul miste tryk eller punktere. Undgå skarpe genstande og hold øje med dækkenes tilstand.']
      ]),
      field('Konstruktion', spec.construction, [
        ['Modellens vigtigste funktion.', spec.constructionNote],
        ['Brug den rigtigt.', 'Sørg for at gitter, lad eller presenning sidder korrekt, før du begynder at trække en tung vogn.']
      ]),
      field('Samling', '5–10 min.', [
        ['Oplyst samletid.', 'Produktbeskrivelsen angiver, at vognen kan samles på cirka 5–10 minutter. Første samling kan tage længere tid, når du lærer delene at kende.'],
        ['Kontrollér før brug.', 'Efter samling bør du sikre, at hjul og øvrige forbindelser sidder fast, inden du lægger last på ladet.']
      ]),
      field('Egenvægt', spec.weight, [
        ['Vognens egen vægt.', `Uden last vejer modellen ${spec.weight}. Tag højde for den vægt, hvis vognen skal løftes ind i bil eller op ad trapper.`],
        ['Levering og plads.', spec.load === '500 kg' ? 'På grund af vægten oplyser produktbeskrivelsen, at denne model ikke kan leveres til pakkeshop.' : 'Sammenlign også vognens mål med pladsen, hvor den skal opbevares.']
      ])
    ]
  });

  const buildHandTruck = () => ({
    heading: 'Detaljer om denne bagagesækkevogn',
    intro: 'Få nemt overblikket over belastning, hjul og transport',
    fields: [
      field('Bæreevne', '80 kg', [
        ['Til tungere bagage.', 'Sækkevognen er oplyst til højst 80 kg. Anbring tunge tasker lavt og tæt på stellet, så de er lettere at styre.'],
        ['Hold lasten fast.', 'Maksimal belastning fortæller ikke, at enhver form eller størrelse af bagage kan stå sikkert på vognen.']
      ]),
      field('Foldning', 'Foldbar', [
        ['Fylder mindre efter brug.', 'Sækkevognen kan foldes sammen, så den er lettere at have med i bilen eller opbevare mellem turene.'],
        ['Før du læsser.', 'Kontrollér, at vognen er helt foldet ud og står stabilt, før du sætter bagage på den.']
      ]),
      field('Hjul', 'Punkterfrie', [
        ['Ingen oppumpning.', 'Produktbeskrivelsen angiver punkterfrie dæk, som ikke skal pumpes op undervejs.'],
        ['Tilpas farten.', 'Kør roligt over kanter og ujævnt underlag, især når vognen er tungt læsset.']
      ]),
      field('Fastspænding', 'Elastik medfølger', [
        ['Hold bagagen på plads.', 'En elastik følger med til fastspænding. Brug den, så bagagen ikke glider frem eller til siden under transport.'],
        ['Kontrollér undervejs.', 'En elastik erstatter ikke en stabil placering. Stram den efter behov, hvis lasten flytter sig.']
      ]),
      field('Anvendelse', 'Bagage og udstyr', [
        ['Når du ikke vil bære alt.', 'Modellen er beskrevet til transport af tungere bagage. Den er et alternativ til at bære flere tasker ad gangen.'],
        ['Vælg efter godset.', 'Se om tasker og kasser kan hvile stabilt mod stellet, før du bruger den til større eller skæve genstande.']
      ]),
      field('Mål og egenvægt', 'Ikke oplyst', [
        ['Ingen tal i beskrivelsen.', 'Produktbeskrivelsen angiver hverken præcise mål eller vognens egenvægt. Vi viser derfor ikke et gættet tal.'],
        ['Hvis pladsen er afgørende.', 'Kontrollér de manglende mål med kundeservice, hvis vognen skal kunne være i et bestemt skab eller bagagerum.']
      ])
    ]
  });

  const buildAccessory = (kind) => {
    const isRoof = kind === 'roof';
    const name = isRoof ? 'tag' : 'regnslag';
    return {
      heading: `Detaljer om dette ${name}`,
      intro: 'Få nemt overblikket over pasform, beskyttelse og montering',
      fields: [
        field('Passer til', 'Premium · 120 kg', [
          ['Modelbestemt tilbehør.', `Dette ${name} er ifølge produktbeskrivelsen lavet til den foldbare Premium-trækvogn med maks. 120 kg bæreevne.`],
          ['Ikke universelt.', 'Beskrivelsen lover ikke pasform til andre trækvogne. Sammenlign modellen, før du bestiller tilbehøret.']
        ]),
        field('Beskyttelse', 'Regn og snavs', [
          ['Skærmer oppakningen.', `Tilbehøret er beskrevet som beskyttelse mod regn, støv og snavs, så udstyret i vognen er bedre skærmet på tur.`],
          ['Pak følsomt udstyr ekstra godt.', 'Ved længerevarende regn bør elektronik og andet fugtfølsomt udstyr stadig ligge i vandtætte poser.']
        ]),
        field('Montering', isRoof ? 'Aftageligt tag' : 'Nem montering', [
          ['Hurtigt på vognen.', isRoof ? 'Taget er aftageligt og kan monteres, når du ønsker overdækning af vognen.' : 'Regnslaget er beskrevet som let at montere med stabil pasform på den nævnte trækvogn.'],
          ['Kontrollér pasformen.', 'Sæt tilbehøret rigtigt på, og kontrollér at det sidder fast, før vognen trækkes af sted.']
        ]),
        field('Anvendelse', isRoof ? 'Overdækket vogn' : 'Dækket oppakning', [
          ['Når vejret skifter.', isRoof ? 'Det aftagelige tag giver vognen overdækning under transport af udstyr.' : 'Regnslaget lægges over lasten for at hjælpe med at holde udstyr og oppakning tørt.'],
          ['Placer lasten sikkert.', 'Selv med overdækning skal bagagen ligge stabilt i vognen og være inden for dens oplyste bæreevne.']
        ]),
        field('Materiale', 'Slidstærkt', [
          ['Beskrivelsens materialeoplysning.', 'Produktteksten kalder materialet slidstærkt, men angiver ikke en bestemt stoftype eller et vandsøjletryk.'],
          ['Pas på overfladen.', 'Undgå skarpe genstande mod materialet, og lad det tørre, før det lægges væk efter en våd tur.']
        ]),
        field('Mål og vægt', 'Ikke oplyst', [
          ['Ingen præcise mål.', `Produktbeskrivelsen oplyser ikke mål eller vægt for ${name === 'tag' ? 'taget' : 'regnslaget'}. Vi viser derfor ikke tal, der ikke kan bekræftes.`],
          ['Pasformen er vigtigst.', 'Kontrollér i stedet, at din trækvogn er den nævnte Premium-model på 120 kg.']
        ])
      ]
    };
  };

  roots.forEach((root) => {
    const source = root.querySelector('[data-wagon-product-data]');
    if (!source) return;
    let product;
    try {
      product = JSON.parse(source.textContent);
    } catch (error) {
      return;
    }

    const handle = product.handle;
    let data;
    if (foldableWagons[handle]) data = buildFoldable(foldableWagons[handle]);
    else if (utilityWagons[handle]) data = buildUtility(utilityWagons[handle]);
    else if (handle === 'saekkevogn') data = buildHandTruck();
    else if (handle === 'tag-til-premium-traekvogn') data = buildAccessory('roof');
    else if (handle === 'regnslag-til-premium-traekvogn') data = buildAccessory('cover');
    else return;

    if (data.fields.length !== 6) return;
    root.querySelector('[data-wagon-heading]').textContent = data.heading;
    root.querySelector('[data-wagon-intro]').textContent = data.intro;
    root.querySelectorAll('[data-wagon-detail]').forEach((item, index) => {
      const detail = data.fields[index];
      item.querySelector('[data-detail-label]').textContent = detail.label;
      item.querySelector('[data-detail-value]').textContent = detail.value;
      item.querySelector('[data-detail-body]').innerHTML = detail.body;
    });

    const details = root.querySelectorAll('details');
    details.forEach((detail) => detail.addEventListener('toggle', () => {
      if (!detail.open) return;
      details.forEach((other) => {
        if (other !== detail) other.open = false;
      });
    }));
    root.hidden = false;
  });
})();
